// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-detail-attributes-tile .field-label{align-self:stretch;color:#616161;font-size:12px;font-style:normal;font-weight:400;line-height:normal;text-shadow:0 0 0 transparent}.location-detail-attributes-tile .field-value{align-self:stretch;color:#000;font-size:12px;font-style:normal;font-weight:400;line-height:normal}", ""]);
// Exports
module.exports = exports;
